import {LANG_RU} from "./ru"

export const LANG_GLOBAL = LANG_RU

export function t(from: string) {
    return LANG_GLOBAL[from] ?? from
}